exports.onInitialClientRender = () => {
  setTimeout(() => {
    document.getElementById('___loader').style.display = 'none'
  }, 500)
}
